import React from 'react';
import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { BasicPrivilegeConfigEditForm } from '../forms/BasicPrivilegeConfigEditForm';

export function BasicPrivilegeCreateEditModal({ closeModal, form }: any) {
  const { t } = useSonTranslation('PrivilegeConfig');

  return (
    <ModalDialog closeModal={closeModal} headline={t('addBasicPrivilege')} initialFocusIndex={1}>
      <BasicPrivilegeConfigEditForm form={form} />
    </ModalDialog>
  );
}
